import { useEffect } from "react";
import { LOGO_URL } from "./Masthead";

const SITE = "The Vainor India";
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  let el = document.getElementById("article-jsonld");
  if (!data) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "article-jsonld";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Seo({ title, description, image, path, article }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — सत्य • निष्पक्षता • निर्भीकता`;
    document.title = fullTitle;
    const desc = description || "देश, विदेश, राजनीति, खेल, मनोरंजन, टेक की ताज़ा हिंदी-English ख़बरें।";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", article ? "article" : "website");
    setMeta("property", "og:image", image || LOGO_URL);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", image || LOGO_URL);
    if (path) {
      setMeta("property", "og:url", `${BASE}${path}`);
      setLink("canonical", `${BASE}${path}`);
    }
    setJsonLd(article || null);
    return () => setJsonLd(null);
  }, [title, description, image, path, article]);
  return null;
}
